import React from "react";
import { ProgressBar } from "../../atoms/ProgressBar";
import { Spinner } from "../../atoms/Spinner";
import { TagChip } from "../../atoms/TagChip";
import { DetailField } from "../DetailField";
import { TagRow } from "../FieldDetailCardHeader/FieldDetailCardHeader.styles";
import {
  ErrorMessage,
  RetryButton,
} from "../DataModelFieldSectionList/DataModelFieldSectionList.styles";
import {
  Body,
  BodyErrorBlock,
  BodyLoadingRow,
  Completeness,
  CompletenessLabel,
  Description,
  StatCell,
  StatGrid,
} from "./FieldDetailCardBody.styles";
import type { FieldDetailCardBodyProps } from "./FieldDetailCardBody.types";

/** Field hover card body — summary, completeness, stat tiles and tags; or its loading / error state. */
export const FieldDetailCardBody: React.FC<FieldDetailCardBodyProps> = ({
  state,
  onRetry,
  completenessLabelId,
  testId,
  className,
}) => (
  <Body data-testid={testId} className={className} aria-busy={state.kind === "loading"}>
    {state.kind === "loading" && (
      <BodyLoadingRow role="status">
        <Spinner size={16} />
        {state.message}
      </BodyLoadingRow>
    )}

    {state.kind === "error" && (
      <BodyErrorBlock role="alert">
        <ErrorMessage>{state.message}</ErrorMessage>
        <RetryButton type="button" onClick={() => onRetry()}>
          {state.retryLabel}
        </RetryButton>
      </BodyErrorBlock>
    )}

    {state.kind === "ready" && (
      <>
        <Description>{state.stats.description}</Description>
        <Completeness>
          <CompletenessLabel id={completenessLabelId}>{state.completenessLabel}</CompletenessLabel>
          <ProgressBar
            value={state.stats.completeness.pct}
            valueLabel={state.stats.completeness.label}
            ariaLabelledBy={completenessLabelId}
          />
        </Completeness>
        <StatGrid>
          {state.stats.stats.map((stat) => (
            <StatCell key={stat.id} $span={stat.span} data-testid={`field-detail-stat-${stat.id}`}>
              <DetailField boxed size="sm" label={stat.label} value={stat.value} />
            </StatCell>
          ))}
        </StatGrid>
        {state.chips.length > 0 ? (
          <TagRow>
            {state.chips.map((chip) => (
              <TagChip key={chip} label={chip} />
            ))}
          </TagRow>
        ) : null}
      </>
    )}
  </Body>
);

export default FieldDetailCardBody;
